<template>
  <BlockUI :loading="block" />
  <div
    class="container-fluid bg-dark pt-4"
    style="height: 100%"
  >
    <h1 class="text-white">Create Database</h1>
    <div class="row gy-5 g-xl-8">
      <!-- Admin -->
      <div class="col-xxl-4 p-5 rounded">
        <h3 class="text-white">Admin Info</h3>
        <div class="p-4 rounded bg-transparent">
          <!-- First Name -->
          <div>
            <label
              class="col-lg-4 col-form-label fw-bold fs-6 text-light"
              for="fname"
              >Admin First Name</label
            >
            <input
              type="text"
              id="fname"
              class="form-control form-control-lg fs-6"
              v-model="InstalData.AdminFirstname"
            />
          </div>
          <!-- Last Name -->
          <div>
            <label
              class="col-lg-4 col-form-label fw-bold fs-6 text-light"
              for="lname"
              >Admin Last Name</label
            >
            <input
              type="text"
              id="lname"
              class="form-control form-control-lg fs-6"
              v-model="InstalData.AdminLastname"
            />
          </div>
          <!-- E-Mail -->
          <div>
            <label
              class="col-lg-4 col-form-label fw-bold fs-6 text-light"
              for="email"
              >Admin E-mail</label
            >
            <input
              type="text"
              id="email"
              class="form-control form-control-lg fs-6"
              v-model="InstalData.AdminEmail"
            />
          </div>
          <!-- Password -->
          <div>
            <label
              class="col-lg-4 col-form-label fw-bold fs-6 text-light"
              for="password"
              >Admin Password</label
            >
            <input
              type="password"
              id="password"
              class="form-control form-control-lg fs-6"
              v-model="InstalData.AdminPassword"
            />
          </div>
          <!-- Confirm Password -->
          <div>
            <label
              class="col-lg-4 col-form-label fw-bold fs-6 text-light"
              for="confirm-password"
              >Confirm Password</label
            >
            <input
              type="password"
              id="confirm-password"
              class="form-control form-control-lg fs-6"
              v-model="InstalData.ConfirmPassword"
              @keydown="confimPassword"
            />
          </div>
          <div v-if="confirm">
            <label
              class="col-lg-12 col-form-label fw-bold fs-6 text-danger"
              for="confirm-password"
              >Confirm password doesn't match !</label
            >
          </div>
        </div>
      </div>
      <!-- Company -->
      <div class="col-xxl-4 p-5">
        <h3 class="text-white">Company Info</h3>
        <div class="p-4 rounded bg-transparent">
          <!-- Company Name -->
          <div>
            <label
              class="col-lg-4 col-form-label fw-bold fs-6 text-light"
              for="comp-name"
              >Company Name</label
            >
            <input
              type="text"
              id="comp-name"
              class="form-control form-control-lg fs-6"
              v-model="InstalData.CompanyName"
            />
          </div>
          <!-- Company Email -->
          <div>
            <label
              class="col-lg-4 col-form-label fw-bold fs-6 text-light"
              for="comp-email"
              >Company Email</label
            >
            <input
              type="text"
              id="comp-email"
              class="form-control form-control-lg fs-6"
              v-model="InstalData.CompanyEmail"
            />
          </div>
          <!-- Company Phone -->
          <div>
            <label
              class="col-lg-4 col-form-label fw-bold fs-6 text-light"
              for="comp-phone"
              >Company Phone</label
            >
            <input
              type="text"
              id="comp-phone"
              class="form-control form-control-lg fs-6"
              v-model="InstalData.CompanyPhoneNumber"
            />
          </div>
          <!-- Company Adress -->
          <div>
            <label
              class="col-lg-4 col-form-label fw-bold fs-6 text-light"
              for="comp-phone"
              >Company Adress</label
            >
            <textarea
              id="comp-phone"
              class="form-control form-control-lg fs-6"
              v-model="InstalData.CompanyAddress"
            />
          </div>

          <!-- Standard Language -->
          <div>
            <label class="col-lg-4 col-form-label fw-bold fs-6 text-light">Standard Language</label>
            <Dropdown
              class="form-control form-control-sm"
              style="padding: 5px !important"
              v-model="InstalData.DefaultLanguageId"
              :options="Languages"
              optionLabel="Value"
              optionValue="Id"
              placeholder="Select a Standard Language"
            />
          </div>

          <!-- Working Languages -->
          <div>
            <label class="col-lg-4 col-form-label fw-bold fs-6 text-light">Working Languages</label>
            <MultiSelect
              v-model="selectedLanguages"
              :options="Languages"
              filter
              optionLabel="Value"
              placeholder="Select Languages"
              class="form-control form-control-sm"
              style="padding: 5px !important"
            />
          </div>
        </div>
      </div>
      <!-- Data Base -->
      <div class="col-xxl-4 p-5 bg-transparent">
        <h3 class="text-white">Database Setting</h3>
        <div class="p-4 rounded bg-transparent">
          <div v-if="!ConnectionInfo">
            <!-- Server Name -->
            <div>
              <label
                class="col-lg-4 col-form-label fw-bold fs-6 text-light"
                for="srv-name"
                >Server Name</label
              >
              <input
                type="text"
                id="srv-name"
                class="form-control form-control-lg fs-6"
                v-model="InstalData.ServerName"
              />
            </div>
            <!-- Database Name -->
            <div>
              <label
                class="col-lg-4 col-form-label fw-bold fs-6 text-light"
                for="db-name"
                >Database Name</label
              >
              <input
                type="text"
                id="db-name"
                class="form-control form-control-lg fs-6"
                v-model="InstalData.DatabaseName"
              />
            </div>

            <!-- User Name -->
            <div>
              <label
                class="col-lg-4 col-form-label fw-bold fs-6 text-light"
                for="db-user-name"
                >Database User Name</label
              >
              <input
                type="text"
                id="db-user-name"
                class="form-control form-control-lg fs-6"
                v-model="InstalData.Username"
              />
            </div>
            <!-- Password -->
            <div>
              <label
                class="col-lg-4 col-form-label fw-bold fs-6 text-light"
                for="db-password"
                >Database Password</label
              >
              <input
                type="password"
                id="db-password"
                class="form-control form-control-lg fs-6"
                v-model="InstalData.Password"
              />
            </div>
          </div>
          <div class="form-check form-check-custom form-check-solid">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="ConnectionInfo"
              id="ConnectionInfo"
            />
            <label
              class="form-check-label col-lg-4 col-form-label fw-bold fs-6 text-light"
              for="ConnectionInfo"
            >
              Connection Info
            </label>
          </div>
          <div v-if="ConnectionInfo">
            <div>
              <label
                class="col-lg-6 col-form-label fw-bold fs-6 text-light"
                for="db-connetct-string"
                >Database Connection String</label
              >
              <input
                type="text"
                id="db-connetct-string"
                class="form-control form-control-lg fs-6"
                v-model="InstalData.DatabaseConnectionString"
              />
            </div>
          </div>

          <div class="form-check form-check-custom form-check-solid">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="InstalData.DisableSampleDataOption"
              id="DisableSampleDataOption"
            />
            <label
              class="form-check-label col-lg-6 col-form-label fw-bold fs-6 text-light"
              for="DisableSampleDataOption"
            >
              Disable Sample Data Option
            </label>
            <div class="form-check form-check-custom form-check-solid ms-2">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="InstalData.InstallSampleData"
                id="InstallSampleData"
              />
              <label
                class="form-check-label col-form-label fw-bold fs-6 text-light"
                for="InstallSampleData"
              >
                Install Sample Data
              </label>
            </div>
          </div>
          <div class="button-content">
            <button
              class="btn btn-light me-2"
              @click="router.push({ name: 'sign-in' })"
            >
              Cancel
            </button>
            <button
              class="btn btn-danger"
              @click="createDB"
            >
              Create
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, h, onMounted } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import { ElNotification } from "element-plus";

const axiosDB = axios.create({
  baseURL: process.env.NODE_ENV === "production" ? "https://api.theauditer.com/api" : "https://test.theauditer.com/api",
});
const block = ref(false);
const router = useRouter();
const confirm = ref(false);
const selectedLanguages = ref([]);
const Languages = ref([]);
const ConnectionInfo = ref(false);
const InstalData = reactive({
  AdminFirstname: "",
  AdminLastname: "",
  AdminEmail: "",
  AdminPassword: "",
  ConfirmPassword: "",
  CompanyName: "",
  CompanyEmail: "",
  CompanyPhoneNumber: "",
  CompanyAddress: "",
  ServerName: "",
  DatabaseName: "",
  Username: "",
  Password: "",
  DatabaseConnectionString: "",
  DisableSampleDataOption: false,
  InstallSampleData: false,
  DefaultLanguageId: "",
  WorkingLanguages: null,
});

const getDBCheckIn = async () => {
  await axiosDB
    .get("/install/prepare")
    .then((response) => {
      if (response.data.Success) {
        Languages.value = response.data.Data.AvailableLanguages;
      } else {
        ElNotification({
          title: "Database Info",
          message: h("a", { style: "color:#343a40" }, "There is a database created"),
          duration: 4500,
          type: "warning",
        });
        setTimeout(() => {
          router.push({ name: "sign-in" });
        }, 4800);
      }
    })
    .catch((errMsg) => {
      console.log(errMsg);
    });
};

const createDB = async () => {
  let lang = [];
  selectedLanguages.value.forEach((item) => {
    lang.push(item.Id);
  });
  InstalData.WorkingLanguages = lang;
  await axiosDB
    .post("/install/begin", InstalData)
    .then((response) => {
      if (response.data.Success) {
        block.value = true;
        ElNotification({
          title: "Database Create",
          message: h("a", { style: "color:#28a745" }, "Database successfully created"),
          duration: 3500,
          type: "success",
        });
        setTimeout(() => {
          router.push({ name: "sign-in" });
          block.value = false;
        }, 3700);
      }
    })
    .catch(
      ElNotification({
        title: "Database Create",
        message: h("a", { style: "color:#dc3545" }, "Database creation failed"),
        duration: 3000,
        type: "error",
      })
    );
};

const confimPassword = () => {
  setTimeout(() => {
    confirm.value = InstalData.AdminPassword !== InstalData.ConfirmPassword ? true : false;
  }, 1000);
};
onMounted(() => {
  getDBCheckIn();
});
</script>

<style>
#app {
  background: transparent;
}
.button-content {
  float: right;
  margin-bottom: 10px;
  margin-top: 20px;
}
</style>
